interface ButtonProps {
  text: string
  onClick?: () => void
}
const CustomButton = ({ text, onClick }: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className="bg-[#0C9443] border border-[#0C9443] text-white px-5 py-[10.5px] rounded-full font-semibold text-base leading-[27px] hover:bg-white hover:text-[#242F3E] hover:border-[#6670851F] hover:shadow-[0_1px_4px_rgba(12,12,13,0.1)] transition-all duration-300 cursor-pointer"
      style={{ all: "unset" }}
    >
      <span className="bg-[#0C9443] border border-[#0C9443] text-white px-5 py-[10.5px] rounded-full font-semibold text-base leading-[27px] hover:bg-white hover:text-[#242F3E] hover:border-[#6670851F] hover:shadow-[0_1px_4px_rgba(12,12,13,0.1)] transition-all duration-300 cursor-pointer inline-block">
        {text}
      </span>
    </button>
  )
}

export default CustomButton
